export default {
      id: "chat-usage",
      viewBox: "0 0 255.35 204.89",
      url: __webpack_public_path__ + "live-atlas/img/icons.e641665a.svg#chat",
      toString: function () {
        return this.url;
      }
    }